import { a } from '../global-constants';

export const setPersonalized = (payload) => {
	return {
		type: a.SET_PERSONALIZED,
		payload
	};
};
